import React from 'react';

// Assuming Modal and Button are exported from core/ui
import styled from 'styled-components';

import { Button, Modal } from 'core/ui';

// Assuming reactstrap for modal

interface ReleaseNotesModalProps {
  isOpen: boolean;
  toggle: () => void;
  content: string;
}

export const ReleaseNotesModal: React.FC<ReleaseNotesModalProps> = ({ isOpen, toggle, content }) => {
  return (
    <Modal show={isOpen} onHide={toggle}>
      <ModalBodyDiv>
        {/* Use dangerouslySetInnerHTML to render HTML content from the template */}
        {/* Ensure that the content is trusted or sanitized if it can come from user input */}
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </ModalBodyDiv>
      <ModalFooterDiv>
        <Button onClick={toggle}>Close</Button>
      </ModalFooterDiv>
    </Modal>
  );
};

const ModalBodyDiv = styled.div`
  padding: 16px;
  // Add any specific styling for the body here
  max-height: 70vh;
  overflow-y: auto;
`;

const ModalFooterDiv = styled.div`
  padding: 16px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #eee; // Example separator
`;
